import {Injectable, inject} from '@angular/core'
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router'
import {filter} from 'rxjs'
import {isMonitoringEventId} from '@models/monitoring/monitoring-event'
import {MonitoringService} from './monitoring.service'

@Injectable({providedIn: 'root'})
export class MonitoringRouteTracker {
  private readonly router = inject(Router)
  private readonly activatedRoute = inject(ActivatedRoute)
  private readonly monitoring = inject(MonitoringService)

  init(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      const monitor = this.leafData().monitor
      if (isMonitoringEventId(monitor)) {
        this.monitoring.track(monitor)
      }
    })
  }

  private leafData(): Record<string, unknown> {
    let route: ActivatedRoute | null = this.activatedRoute
    while (route?.firstChild) {
      route = route.firstChild
    }
    return route?.snapshot?.data ?? {}
  }
}
